import TipoChecklistEntrega from '@/model/resource/TipoChecklistEntrega'
import {bool, InputType, Schema} from 'simpli-web-sdk'

export default (model: TipoChecklistEntrega): Schema => ({
    idTipoChecklistEntregaPk: {
        content: model.idTipoChecklistEntregaPk,
        editable: false,
    },
    descricao: {
        content: model.descricao,
    },

    ativo: {
        content: bool(model.ativo),
        input: InputType.CHECKBOX,
    },
})
